import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Checkbox, Dropdown,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import './style.scss';
import PropTypes from 'prop-types';

function CustomDocumentColumns({
  visibleColumns, setVisibleColumns, customColumns, data, updateData,
}) {
  // Function to update data visibility based on visibleColumns
  const updateDataVisibility = (updatedVisibleColumns) => {
    const updatedData = data?.map((item) => {
      const updatedLineCustomFields = item?.lineCustomFields?.map((field) => {
        const matchingColumn = updatedVisibleColumns[field?.fieldName?.toUpperCase()];
        if (matchingColumn) {
          return {
            ...field,
            visible: matchingColumn.visible,
          };
        }
        return field;
      });
      return {
        ...item,
        lineCustomFields: updatedLineCustomFields,
      };
    });
    updateData(updatedData);
  };
  return (
    <Dropdown
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      overlay={(
        <div className="custom-doc-columns__content">
          <div className="custom-doc-columns__content-section">
            <H3Text text="Visible Columns" className="custom-doc-columns__content-title" />
            {
              Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                <div key={key}>
                  <Checkbox
                    disabled={visibleColumns[key]?.required || visibleColumns[key]?.disabled}
                    checked={visibleColumns[key]?.visible}
                    onChange={() => {
                      const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                      visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                      setVisibleColumns(visibleColumnsCopy);
                      updateDataVisibility(visibleColumnsCopy);
                    }}
                  >
                    {visibleColumns[key]?.label}
                  </Checkbox>
                </div>
              ))
            }
          </div>

          {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length > 0 && (
            <div className="custom-doc-columns__content-section">
              <H3Text text="Other Columns" className="custom-doc-columns__content-title" />
              {
                Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                  <div key={key}>
                    <Checkbox
                      disabled={visibleColumns[key]?.required || visibleColumns[key]?.disabled}
                      checked={visibleColumns[key]?.visible}
                      onChange={() => {
                        const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                        visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                        setVisibleColumns(visibleColumnsCopy);
                        updateDataVisibility(visibleColumnsCopy);
                      }}
                    >
                      {visibleColumns[key]?.label}
                    </Checkbox>
                  </div>
                ))
              }
            </div>
          )}

        </div>
      )}
      trigger={['click']}
      placement="topRight"
    >
      <div className="custom-doc-columns__wrapper">
        <FontAwesomeIcon icon={faGear} />
        &nbsp;
        More Columns
      </div>
    </Dropdown>
  );
}

const mapStateToProps = ({

}) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

CustomDocumentColumns.propTypes = {
  visibleColumns: PropTypes.any,
  setVisibleColumns: PropTypes.any,
  customColumns: PropTypes.any,
  data: PropTypes.any,
  updateData: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomDocumentColumns));
